const popupWalletMethods = new Set([
  'paypal',
  'venmo',
  'applepay',
  'googlepay',
  'bit',
  'bit cardcom',
  'dafpay'
])

export function shouldCancelSubmitOnPopupClosed(paymentMethod?: string | null) {
  if (!paymentMethod) return false

  return !popupWalletMethods.has(paymentMethod.toLowerCase())
}
